import React from 'react';
import { Box, type Types } from '@fiverr-private/theme';
import type { DotIndicatorProps } from './types';
import { COLOR_BY_TYPE, PROPS_BY_SIZE, getPropsByPosition } from './constants';

const DotIndicator = ({
  size = 'lg',
  type = 'neutral',
  position = 'bottom-right',
  isOverlay = false,
  content = '',
  offset = 0,
  borderWidth = 'sm',
  dataTrackTag = 'dot_indicator',
  dataTrackValue,
}: DotIndicatorProps) => {
  const currentValue = size === 'lg' ? content : null;
  const hasValue = Boolean(currentValue);
  const positionProps = isOverlay ? getPropsByPosition(offset, position, borderWidth) : {};
  const overlayProps: Pick<Types.BoxType, 'position' | 'zIndex'> = isOverlay
    ? {
        position: 'absolute',
        zIndex: '1',
      }
    : {};

  return (
    <Box
      dataTrackTag={dataTrackTag}
      dataTrackValue={dataTrackValue}
      display="flex"
      alignItems="center"
      justifyContent="center"
      borderWidth={borderWidth}
      borderColor="white"
      borderStyle="solid"
      backgroundColor={COLOR_BY_TYPE[type]}
      borderRadius="circle"
      {...positionProps}
      {...overlayProps}
      {...(hasValue
        ? {
            fontSize: 'b_xs',
            lineHeight: 'b_xxs',
            fontWeight: 'bold',
            color: 'white',
            paddingX: '1',
            paddingY: 'px',
            width: 'fit-content',
            minWidth: '8px',
          }
        : PROPS_BY_SIZE[size])}
    >
      {currentValue}
    </Box>
  );
};

DotIndicator.displayName = 'DotIndicator';
export default DotIndicator;
